import api from './index';
//
let exports = {};

// ----------------- 财务凭据存根 --------------

// 财务凭据存根
exports.getFiscalProofStubPageList = function (data, callback) {
    api.post('/fiscal/proof/stub/page/list/get')
    .data(data)
    .done(callback)
    .go()
};

// 获取财务凭据项列表
exports.getFiscalProofItemPageList = function (data, callback) {
    api.post('/fiscal/proof/item/page/list/get')
    .data(data)
    .done(callback)
    .go()
};
// 获取财务凭据实际推送条目列表
exports.getFiscalProofItemDtoPageList = function (data, callback) {
    api.post('/fiscal/proof/item/dto/page/list/get')
    .data(data)
    .done(callback)
    .go()
};

exports.getFiscalProofItemForExport = function (data, callback) {
    api.post('/fiscal/proof/item/list/export/do')
    .data(data)
    .done(callback)
    .go()
};
// 推送的财务凭据项
exports.getPushedFiscalProofItemList = function (data, callback) {
    api.post('/fiscal/proof/pushed/item/page/list/get')
    .data(data)
    .done(callback)
    .go()
}
// ----------------- 业务凭单 --------------
exports.getPurchBizProofPageList = function (data, callback) {
    api.post('/fiscal/proof/purch/biz/proof/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getPurchBizItemPageList = function (data, callback) {
    api.post('/fiscal/proof/purch/biz/proof/item/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getAssetDeprProofPageList = function (data, callback) {
    api.post('/fiscal/proof/asset/depr/proof/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getAssetDeprProofItemPageList = function (data, callback) {
    api.post('/fiscal/proof/asset/depr/proof/item/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getDeprAdjustProofPageList = function (data, callback) {
    api.post('/fiscal/proof/depr/adjust/proof/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getDeprAdjustProofItemPageList = function (data, callback) {
    api.post('/fiscal/proof/depr/adjust/proof/item/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getTransBizProofStubPageList = function (data, callback) {
    api.post('/fiscal/proof/trans/biz/proof/page/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getTransBizItemStubPageList = function (data, callback) {
    api.post('/fiscal/proof/trans/biz/item/page/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getScrapBizProofStubPageList = function (data, callback) {
    api.post('/fiscal/proof/scrap/biz/proof/page/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getScrapBizItemStubPageList = function (data, callback) {
    api.post('/fiscal/proof/scrap/biz/item/page/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getClearBizProofPageList = function (data, callback) {
    api.post('/fiscal/proof/clear/biz/proof/page/list/get')
    .data(data)
    .done(callback)
    .go()
};
exports.getClearBizItemPageList = function (data, callback) {
    api.post('/fiscal/proof/clear/biz/item/page/list/get')
    .data(data)
    .done(callback)
    .go()
};
// 冲销
exports.updateFiscalBizProofForRevoked = function (data, callback) {
    api.post('/fiscal/proof/revoked/do')
    .data(data)
    .done(callback)
    .go()
};
// 冲销
exports.updateFiscalBizProofForRevokedByBizVoucherId = function (data, callback) {
    api.post('/fiscal/proof/revoked/do/by/bizVoucherId')
    .data(data)
    .done(callback)
    .go()
};
// 重新生凭
exports.doRebuildCreateFiscalProof = function (data, callback) {
    api.post('/fiscal/proof/rebuild/create/do')
    .data(data)
    .done(callback)
    .go()
};
// 重新生凭
exports.doRebuildCreateFiscalProofByBizVoucherId = function (data, callback) {
    api.post('/fiscal/proof/rebuild/create/do/by/bizVoucherId')
    .data(data)
    .done(callback)
    .go()
};

// ----------------- 财务凭据 --------------
exports.getFiscalProofPageList = function (data, callback) {
    api.post('/fiscal/proof/page/list/get')
    .data(data)
    .done(callback)
    .go()
};
// 推送财务凭据
exports.doPushFiscalProof = function (data/*id*/, callback) {
    api.post('/fiscal/proof/joint/push/do')
    .data(data)
    .done(callback)
    .go()
};
// 获取财务凭据数据
exports.getFiscalProofDto = function (params, callback) {
    api.get('/fiscal/proof/joint/dto/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go()
};
export default exports



//////////////////
// WEBPACK FOOTER
// ./src/api/fiscalProof.js
// module id = 68
// module chunks = 0